import { createSelector } from 'reselect'
import { selectHost } from 'selectors/location'
import { selectCurrentTicketId } from './selectCurrentTicketId'

export const selectCurrentTicketUrl = createSelector(
  selectCurrentTicketId,
  selectHost,
  (id, host) => `https://${host}/tickets/${id}`
)
